import React, {forwardRef, useState} from 'react';
import BaseSimpleItemBrowser from "../BaseSimplePage/BaseSimpleItemBrowser";
import EventsTheatreItemBrowserHeader from "./EventsTheatreItemBrowserHeader";

const EventsTheatreItemBrowser = forwardRef(({
                                                   filterExtraParams,
                                                   ...restProps
                                               }, ref) => {

    const [cityId, setCityId] = useState(0);
    const [locationId, setLocationId] = useState(0);
    const [tagId, setTagId] = useState(0);
    const [datesMode, setDatesMode] = useState("any"); // all|active|deleted
    const [cardType, setCardType] = useState("all"); // any|with_dates|without_dates

    const [modFilterExtraParams, setModFilterExtraParams] = useState({
        ...filterExtraParams,
        dates_mode: datesMode,
        filter_mode: cardType
    });

    function renderHeader(headerProps) {
        return <EventsTheatreItemBrowserHeader
            {...headerProps}
            cityId={cityId}
            setCityId={handleCityIdChange}
            locationId={locationId}
            setLocationId={handleLocationIdChange}
            tagId={tagId}
            setTagId={handleTagIdChange}
            datesMode={datesMode}
            setDatesMode={handleDatesModeChange}
            cardType={cardType}
            setCardType={handleCardTypeChange}
        />
    }

    function handleCityIdChange(value) {
        const newFilterExtraParams = {...modFilterExtraParams};
        if (value === 0)
            delete newFilterExtraParams.city_id;
        else
            newFilterExtraParams.city_id = value;

        setCityId(value);
        setModFilterExtraParams(newFilterExtraParams);
        ref.current.onFilterEdit(true);
    }

    function handleLocationIdChange(value) {
        const newFilterExtraParams = {...modFilterExtraParams};
        if (value === 0)
            delete newFilterExtraParams.location_id;
        else
            newFilterExtraParams.location_id = value;

        setLocationId(value);
        setModFilterExtraParams(newFilterExtraParams);
        ref.current.onFilterEdit(true);
    }

    function handleTagIdChange(value) {
        const newFilterExtraParams = {...modFilterExtraParams};
        if (value === 0)
            delete newFilterExtraParams.tag_id;
        else
            newFilterExtraParams.tag_id = value;

        setTagId(value);
        setModFilterExtraParams(newFilterExtraParams);
        ref.current.onFilterEdit(true);
    }

    function handleDatesModeChange(value) {
        const newFilterExtraParams = {...modFilterExtraParams};
        newFilterExtraParams.dates_mode = value;

        setDatesMode(value);
        setModFilterExtraParams(newFilterExtraParams);
        ref.current.onFilterEdit(true);
    }

    function handleCardTypeChange(value) {
        const newFilterExtraParams = {...modFilterExtraParams};
        newFilterExtraParams.filter_mode = value;

        setCardType(value);
        setModFilterExtraParams(newFilterExtraParams);
        ref.current.onFilterEdit(true);
    }

    return (
        <BaseSimpleItemBrowser
            {...restProps}
            ref={ref}
            getItemSubtitleFunc={getItemSubtitle}
            getItemUptitleFunc={getItemUptitle}
            renderHeaderFunc={renderHeader}
            filterExtraParams={modFilterExtraParams}
        />
    );
});

function getItemSubtitle(item) {
    return `${item.location_name ?? "?"}`;
}

function getItemUptitle(item) {
    return item.deleted_at ? "АРХИВ" : "";
}

export default EventsTheatreItemBrowser;